import { render, staticRenderFns } from "./DialogEditKeyword.vue?vue&type=template&id=2fc3b071&scoped=true"
import script from "./DialogEditKeyword.vue?vue&type=script&lang=js"
export * from "./DialogEditKeyword.vue?vue&type=script&lang=js"
import style0 from "./DialogEditKeyword.vue?vue&type=style&index=0&id=2fc3b071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3b071",
  null
  
)

export default component.exports